import { render, staticRenderFns } from "./AgendaTab.vue?vue&type=template&id=ae7c0e00"
import script from "./AgendaTab.vue?vue&type=script&lang=js"
export * from "./AgendaTab.vue?vue&type=script&lang=js"
import style0 from "./AgendaTab.vue?vue&type=style&index=0&id=ae7c0e00&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports